import { Directive, HostBinding, input, model } from '@angular/core';

@Directive({
  selector: '[panRadioGroup]',
  standalone: false,
})
export class PanRadioGroupDirective {
  public panRadioGroup = model<string | number | boolean | undefined>();
  public ariaLabel = input<string>('Radio Group');

  @HostBinding('attr.role')
  public role = 'radiogroup';

  @HostBinding('attr.aria-label')
  public get hostAriaLabel() {
    return this.ariaLabel();
  }
}
